<template>
    <div></div>
</template>

<script>
    import { ref, onMounted, watchEffect } from "vue";
    import { useRoute, useRouter } from "vue-router";

    import { G, ajax } from "@/_common";

    export default {
        name: "PDFViews",
        title: "PDF",
        props: {
            url: String,
            data: Object,
        },
        setup() {
            const route = useRoute();
            const router = useRouter();

            const pdf_uri = ref(null);

            watchEffect(() => {});

            onMounted(async () => {
                await ajax({
                    url:
                        G.ajaxBaseUrl +
                        `/${route.params.view}/az/pdf/` + (route.params.id !== undefined ? (route.params.id + '/') : '') +
                        decodeURIComponent(route.params.url) + '?t=' + new Date().valueOf(),
                    responseType: "arraybuffer",
                    success: (e) => {
                        pdf_uri.value = URL.createObjectURL(
                            new Blob([e.data], {
                                type: "application/pdf",
                            })
                        );
                    },
                    error: () => {
                        pdf_uri.value = 'http://localhost:8080' + router.resolve({ name: 'notfound_full' }).path;
                    },
                });
            });

            return { pdf_uri };
        },
    };
</script>